(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-bottom"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('[data-didomi-preferences]')) return;
    // Queued until the SDK is ready, as Didomi requires for every API call.
    window.didomiOnReady = window.didomiOnReady || [];
    window.didomiOnReady.push((Didomi) => Didomi.preferences.show());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card"]) return;
  try {
    
  let copyButton = document.querySelector('#copy');

  if (copyButton) {
    function copy() {
      let code = copyButton.getAttribute('data-code');
      navigator.clipboard.writeText(code).then(
        function () {
          let successMessage = copyButton.getAttribute('data-success');
          copyButton.textContent = successMessage;
          copyButton.classList.add('success');
        },
        function (err) {
          let errorMessage = copyButton.getAttribute('data-error');
          copyButton.textContent = errorMessage;
          copyButton.classList.add('error');
        }
      );
    }

    copyButton.addEventListener('click', copy);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  document.querySelectorAll('[data-password-access]').forEach((access) => {
    const toggle = access.querySelector('[data-password-toggle]');
    const panel = access.querySelector('[data-password-panel]');

    if (!(toggle instanceof HTMLButtonElement) || !(panel instanceof HTMLElement)) return;

    const input = panel.querySelector('input[type="password"]');

    const setOpen = (open, { focus = true } = {}) => {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));

      if (!focus) return;

      if (open && input instanceof HTMLInputElement) {
        input.focus();
      } else if (!open) {
        toggle.focus();
      }
    };

    toggle.addEventListener('click', () => {
      setOpen(panel.hidden);
    });

    access.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || panel.hidden) return;
      setOpen(false);
    });

    document.addEventListener('click', (event) => {
      if (panel.hidden) return;
      if (event.target instanceof Node && access.contains(event.target)) return;
      setOpen(false, { focus: false });
    });

    if (!panel.hidden && input instanceof HTMLInputElement) {
      input.focus();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
